export default __webpack_public_path__ + "static/media/lifesatisfaction3Img5.a4798e19.png";